export default {
  baseStyle: {
    color: 'var(--colors-primary)',
    size: 'lg',
    borderWidth: '3px',
  },
};
